// extracted by mini-css-extract-plugin
export default {"fieldsWrapper":"manual-payment_fieldsWrapper__vOPQy"};